<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('payment schedules')"
      :columns="columns"
      :column_search="true"
      resource_url="/loan/payment-schedule/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create_schedule">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <payment-schedule-modal ref="schedule_modal" @success="refresh_datatable" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date,
} from "@/utils";
import PaymentScheduleModal from "./payment_schedule_modal/Index.vue";

export default {
  name: "PaymentScheduleDataTable",
  components: { GenericTable, PaymentScheduleModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("due date"),
          searchable: true,
          data: (row) => {
            return `<div class="title is-6">${format_date(row.due_date)}</div>
            <div class="subtitle is-7">${v.$t("installment")} ${
              row.installment_number
            }</div>`;
          },
        },
        {
          title: v.$t("loan"),
          searchable: true,
          data: (row) => {
            return `<div class="title is-6">${row.loan?.loan_number || ""}</div>
            <div class="subtitle is-7">${
              row.loan?.application?.applicant_name || ""
            }</div>`;
          },
        },
        {
          title: v.$t("amounts"),
          searchable: false,
          data: (row) => {
            return `<div class="title is-6">${format_currency(
              row.payment_amount
            )}</div>
            <div class="subtitle is-7">
              ${v.$t("principal")}: ${format_currency(row.principal_amount)}<br>
              ${v.$t("interest")}: ${format_currency(row.interest_amount)}
            </div>`;
          },
        },
        {
          title: v.$t("balance"),
          searchable: false,
          data: (row) => {
            return format_currency(row.balance_after_payment);
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            let statusClass = "";
            switch (row.status) {
              case "pending":
                statusClass = "is-warning";
                break;
              case "paid":
                statusClass = "is-success";
                break;
              case "overdue":
                statusClass = "is-danger";
                break;
              case "partial":
                statusClass = "is-info";
                break;
              default:
                statusClass = "is-dark";
            }
            return `<span class="tag ${statusClass}">${v.$t(
              row.status
            )}</span>`;
          },
        },
        {
          title: v.$t("actions"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.edit_schedule(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure delete schedule"),
                    v,
                    () => {
                      del("/loan/payment-schedule", { uuid: uuid })
                        .then(() => {
                          v.refresh_datatable();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create_schedule() {
      this.$refs.schedule_modal.show_modal();
    },
    edit_schedule(uuid) {
      this.$refs.schedule_modal.show_modal(uuid);
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
  },
};
</script>
